import { UiFloatModal } from "../../../common/modal";
import { RepeatRuleForm } from "../../components/repeatRuleForm/repeatRuleForm";
import { RecurrenceRule } from "../../types/recurrenceRule";
import { autoPlacement, computePosition } from "@floating-ui/dom";

// Side effect import to define custom element.
// eslint-disable-next-line no-duplicate-imports
import "../../components/repeatRuleForm/repeatRuleForm";

type OpenOptions = Readonly<{
    initialValues: RecurrenceRule;
    startDate: Date;
    coords?: {
        x: number;
        y: number;
    };
    isDisabled?: boolean;
}>;

/** Edit repeat rule modal. */
export class EditRepeatRuleModal {

    /** Popup instance. */
    public popup: UiFloatModal;

    private form: RepeatRuleForm;

    public constructor(onUpdate: (event: CustomEvent<RecurrenceRule>) => void) {
        try {
            this.popup = new UiFloatModal(
                "<repeat-rule-form class=\"form full-height\"></repeat-rule-form>",
                true,
                { bottom: true, right: true, left: true },
                { width: 578, height: 148 },
                10002001,
            );
            this.popup.modalComponent.x = 10;
            this.popup.modalComponent.y = 10;
            this.popup.modalComponent.minWidth = 578;
            this.popup.modalComponent.label = "Повтор";
            const form = this.popup.modalComponent.querySelector<RepeatRuleForm>(".form");

            if (form === null) {
                throw new Error("Could not find edit repeat rule form element.");
            }

            this.form = form;
            this.form.onRecurrenceTypeChange = () => {
                this.popup.uiModal.resetSize();
            };

            this.form.addEventListener("repeatRuleFormCancel", this.handleFormCancel.bind(this));
            this.form.addEventListener("repeatRuleFormSubmit", onUpdate);

        } catch(e) {
            console.error("Error <initPopup> >> ", e);
        }
    }

    /**
     * Opens modal.
     * @param options Open options.
     */
    public open(options: OpenOptions): void {
        this.form.disabled = options.isDisabled ?? false;

        this.form.initialValues = options.initialValues;
        this.form.startDate = options.startDate;

        this.popup.uiModal.resetSize();
        this.popup.modalComponent.open();
        if (options.coords != null) {
            this.computePosition(options.coords.x, options.coords.y);
        }
    }

    /** Initial values. */
    public set initialValues(value: RecurrenceRule) {
        this.form.initialValues = value;
    }

    /** Disabled state. */
    public set disabled(value: boolean) {
        this.form.disabled = value;
    }

    /** Closes modal. */
    public close(): void {
        this.popup.modalComponent.close();
    }

    private handleFormCancel(): void {
        this.close();
    }

    private computePosition(x: number, y: number): void {
        const virtualElement = {
            getBoundingClientRect() {
                return {
                    x,
                    y,
                    width: 0,
                    height: 0,
                    top: y,
                    left: x,
                    right: x,
                    bottom: y,
                };
            },
        };

        computePosition(virtualElement, this.popup.root, {
            middleware: [
                autoPlacement({
                    alignment: "start",
                    allowedPlacements: ["left-start", "right-start", "left-end", "right-end"],
                }),
            ],
        }).then(({ x: popupX, y: popupY }) => {
            this.popup.setPosition({ x: popupX, y: popupY });
        }, () => {
            console.error("Could not compute position for editRepeatRuleModal");
        });
    }
}
